<script>
    let total = -1;
    let cargo = 0;

    if (!window.hudStore) window.hudStore = {};
    window.hudStore.setTruckWeight = (t, c) => { total = t; cargo = c; };

    const tons = (kg) => (kg / 1000).toFixed(1);
</script>

{#if total >= 0}
    <div class="truckweight">
        <div class="truckweight__row">
            <span class="truckweight__ico">⚖</span>
            <span class="truckweight__val">{tons(total)} т</span>
        </div>
        {#if cargo > 0}
            <div class="truckweight__cargo">груз {tons(cargo)} т</div>
        {/if}
    </div>
{/if}

<style>
    .truckweight {
        background: rgba(20, 20, 24, 0.72);
        border-radius: 8px;
        padding: 6px 10px;
        color: #fff;
        margin-top: 8px;
        min-width: 86px;
        text-align: center;
    }
    .truckweight__row {
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 6px;
        font-size: 15px;
        font-weight: 600;
    }
    .truckweight__ico { color: #26c281; }
    .truckweight__cargo { font-size: 12px; color: #bdbdbd; margin-top: 2px; }
</style>
